/**
 * The `extensions.code` of the first GraphQL error an Apollo call failed with,
 * which is how the backend says which refusal this was.
 */
export const graphqlErrorCode = (error: unknown): string | undefined => {
  const code = (
    error as { graphQLErrors?: { extensions?: { code?: unknown } }[] } | null
  )?.graphQLErrors?.[0]?.extensions?.code

  return typeof code === 'string' ? code : undefined
}
